// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import lodash from 'lodash'
import moment from 'moment'
import socketIOClient from 'socket.io-client'
import sailsIOClient from 'sails.io.js'

import VTooltip from 'v-tooltip'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import FileUpload from 'vue-upload-component'
import Notify from 'vue2-notify'
import { store } from './store/store.js'
import Filters from './filters.js'
import VueResource from 'vue-resource'
import { Timeline, Graph2d } from 'vue2vis'
import { VueContext } from 'vue-context'
import excel from 'vue-excel-export'

import vueSails from './vue-sails/index.js'
// const vueSails = require('./vue-sails')
const packageInfo = require('../package.json')

Vue.use(excel)

Vue.use(VueResource)
Vue.config.productionTip = false
store.waveVersion = packageInfo.version

// development args
Vue.http.options.root = '/api/'

// production args
if (process.env.NODE_ENV === 'production') {
  Vue.http.options.root = '/'
}

Vue.http.interceptor.before = function (request) {
  if (typeof request.params.showLoader === 'undefined' || request.params.showLoader) {
    store.commit('SET_LOADER', true)
  }
}

// lodash
Object.defineProperty(Vue.prototype, '$_', { value: lodash })

// moment
Object.defineProperty(Vue.prototype, '$moment', { value: moment })

// Socket client - Sails
const io = sailsIOClient(socketIOClient)

// Additional Sails.io.js configuration
io.sails.environment = process.env.NODE_ENV || 'development'
io.sails.reconnection = true
Vue.use(vueSails, io)

// Components Global
// Context Menu
Vue.component('vue-context', VueContext)

// ToolTip
Vue.use(VTooltip)
// datePicker
Vue.use(datePicker)
// uploader
Vue.component('file-upload', FileUpload)
// visjs
Vue.component('timeline', Timeline)
Vue.component('graph2d', Graph2d)

// notify
Vue.use(Notify, {
  visibility: 3000,
  position: 'bottom-right',
  closeButtonClass: 'close',
  width: 'auto'
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.matched.some(record => record.meta.userOnly)) {
    /**
     * @see {@link https://stackoverflow.com/questions/10730362/get-cookie-by-name#answer-40786371}
     * @param name
     * @returns {string}
     */
    const getCookie = name => {
      let a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`)
      return a ? a[1] : ''
    }
    if (getCookie('userid')) {
      next()
    } else {
      router.push({
        name: 'userLogin'
      })
    }
  } else next()
})

Vue.http.interceptors.push((request, next) => {
  // continue to next interceptor
  next((response) => {
    store.commit('SET_LOADER', false)
    if (response.status === 403) {
      let cookies = document.cookie.split(';')

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i]
        var eqPos = cookie.indexOf('=')
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      }

      window.location.href = '/'
    }
  })
})

io.socket.on('disconnect', () => {
  let cookies = document.cookie.split(';')

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i]
    var eqPos = cookie.indexOf('=')
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }

  console.info('on disconnect!')
  // Workaround for Firefox bug making it impossible to navigate out of the
  // web page...
  setTimeout(() => {
    console.info('redirect to /', window.location.href)
    window.location.href = '/'
  }, 5000)
})

// Filters
// Filters.create(Vue)

for (let name in Filters.filters) {
  Vue.filter(name, Filters.filters[name])
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js